export enum DOCTOOL_FIRESTORE_TABLES {
    APPOINTMENT = 'appointments',
}
